<template>

	<div class="bg-white">
		<div ref="gaugeArea"/>
	</div>

</template>

<script>

// This component is based on https://github.com/recogizer/gauge-chart

// import GaugeChart from 'gauge-chart'
// import "gauge-chart/dist/bundle";
import * as GaugeChart from "gauge-chart";

export default {
	name: 'Gauge',

	props: {
		// These are used to build our gauge
		arcLabels: Array,
		rangeLabels: Array,
		centerLabel: String,

		// The amount is used to calculate the percentage
		// The amount should be a number between the two rangeLabels
		amount: Number
	},

	data: function () {
		return {
			gauge: null,

			gaugeOptions: {
				hasNeedle: true,
				needleColor: 'black',
				arcColors: ['rgb(61, 204, 91)', 'rgb(239, 214, 19)', 'rgb(255, 84, 84)'],
				arcDelimiters: [18.75, 62.5],
				arcPadding: 2,
				arcPaddingColor: 'white',
				arcLabels: null,
				arcLabelFontSize: false,
				arcOverEffect: false,

				// label options
				rangeLabel: null,
				centralLabel: null,
				rangeLabelFontSize: 12,
			}
		}
	},

	async mounted()
	{
		// Set the rangelabels
		this.gaugeOptions.rangeLabel = [String(this.rangeLabels[0]), String(this.rangeLabels[1])]

		// Set the arcLabels
		this.gaugeOptions.arcLabels = this.arcLabels

		// Set central label
		this.gaugeOptions.centralLabel = this.centerLabel

		// Create gauge
		this.gauge = GaugeChart.gaugeChart(this.$refs.gaugeArea, $(this.$el).width(), this.gaugeOptions)

		// Calculate the percentage and set it
		this.setValue(this.amount)
	},

	methods:
	{
		setValue(amount)
		{
			// Calculate percentage
			let maxValue = this.rangeLabels[1]
			let percentage = (amount / maxValue) * 100

			// Set the percentage on the gauge
			this.gauge.updateNeedle(percentage)
		},

		update()
		{
			this.setValue(this.amount)
		}

	},

	watch:
	{
		'amount'(newVal, oldVal)
		{
			this.update()
		},

		'centerLabel'(newVal)
		{
			// Set central label
			this.gaugeOptions.centralLabel = this.centerLabel;

			// @ugly
			$('text[font-size="18px"]:last-child', this.$refs['gaugeArea']).text(this.centerLabel);
		},

	}
}
</script>

<style lang="scss" scoped>

	div ::v-deep {
		text {
			font-size: 12px !important;
		}
	}

</style>
